if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Add or update the quantity in formData
        const quantityInput = document.getElementById('hiddenQuantityInput');
        if (quantityInput) {
          formData.set('quantity', quantityInput.value);
        }

        // LN: regalos desbloqueados por pack y complementos marcados (se añaden junto al producto principal)
        // LN: si hay selector por unidad (window.lnPackItems), se añade cada variante elegida en vez de una sola
        let body = formData;
        const inMainProduct = !!this.closest('.product__info-container');
        const lnGifts = inMainProduct && Array.isArray(window.lnGiftItems) ? window.lnGiftItems : [];
        const lnAddons = inMainProduct && Array.isArray(window.lnAddonItems) ? window.lnAddonItems : [];
        const lnPack = inMainProduct && Array.isArray(window.lnPackItems) && window.lnPackItems.length ? window.lnPackItems : null;
        const lnExtra = lnGifts.concat(lnAddons);
        if (lnExtra.length || lnPack) {
          body = new FormData();
          const mainItems = lnPack || [{ id: formData.get('id'), quantity: formData.get('quantity') || 1 }];
          let i = 0;
          mainItems.forEach((item, k) => {
            body.append(`items[${i}][id]`, item.id);
            body.append(`items[${i}][quantity]`, item.quantity || 1);
            if (k === 0) {
              for (const [key, value] of formData.entries()) {
                const match = key.match(/^properties\[(.+)\]$/);
                if (match) body.append(`items[${i}][properties][${match[1]}]`, value);
                if (key === 'selling_plan' && value) body.append(`items[${i}][selling_plan]`, value);
              }
            }
            i++;
          });
          lnExtra.forEach((extra) => {
            body.append(`items[${i}][id]`, extra.id);
            body.append(`items[${i}][quantity]`, extra.quantity || 1);
            Object.entries(extra.properties || {}).forEach(([pk, pv]) => body.append(`items[${i}][properties][${pk}]`, pv));
            i++;
          });
        }

        if (this.cart) {
          body.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          body.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = body;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            if (lnGifts.length && window.lnGiftSync) setTimeout(() => window.lnGiftSync(), 400);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
